import React from "react";
import { Outlet } from "react-router-dom";

import HomeLayout from "../layouts/HomeLayout";
import Navbar from "../containers/Navbar";
import variables from "../themes/base/styles/variables";

const HomeStyle = {
  topSectionStyle: {
    position: "sticky",
    top: 0,
    width: variables.fullWidth,
    backgroundColor: variables.bodyBg,
    zIndex: 1,
  },
  style: {
    position: "relative",
    maxWidth: variables.fullScreenWidth,
    height: variables.fullScreenHeight,
    overflow: "hidden",
  },
  navFullWidth: { width: variables.fullWidth },
};

function Home() {
  return (
    <HomeLayout
      bottomSection={<Outlet />}
      style={HomeStyle.style}
      topSectionStyle={HomeStyle.topSectionStyle}
      topSection={<Navbar />}
    />
  );
}

export default Home;
